import React, { useEffect } from 'react'
import { translate } from 'react-translate'
import News from '../PageHome/components/Noticias'
import ContactForm from '../commons/ContactForm/ContactForm.component'
import { MainBanner } from '../commons/MainBanner/MainBanner.component'
import MarketReportsWidget from '../commons/MarketReportsWidget/MarketReportsWidget.container'
import Imis from '../commons/SliderMarketReports/imi'

import './PageConsultancyAndResearch.scss'

export const PageConsultancyAndResearch = translate('PageConsultancyAndResearch')(function Component({
  t,
  didMount,
  news,
  imis,
}) {

  useEffect(() => {
    didMount()
  }, [])

  const hasImis = imis && imis.length
  const starredImi = hasImis && imis[0]
  const imisForSlider = hasImis && imis.slice(1)

  return <div className='page-consultancy-and-research'>
    <MainBanner
      className='page-consultancy-main-banner'
      backgroundURL={'/assets/images/consultoria-research-bg.jpeg'}
      mainTitle={t('main_title')}
    />
    <div className={'main-text'}>
      <p>{t('main_text_1')}</p>
      <p>{t('main_text_2')}</p>
    </div>
    {starredImi && <MarketReportsWidget imi={starredImi} />}
    {imis && imis.length && <Imis imis={imisForSlider} />}
    {news && news.length && <div className='ljr-bg-grey'>
      <News news={news} />
    </div>}
    <div className='form-container'>
      <ContactForm hideButtonBranches={true}/>
    </div>
  </div>
})



// WEBPACK FOOTER //
// ./src/features/PageConsultancyAndResearch/PageConsultancyAndResearch.component.js